import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { doGetAllWebhooks, doCreateWebhook, doUpdateWebhook, doDeleteWebhook } from './thunk';

const isActionWithPending = (action) => {
  return action.type.endsWith('/pending') && !action.type.includes('NoFetching');
};

const isActionWithFulfilled = (action) => {
  return action.type.endsWith('/fulfilled');
};

const isActionWithFailed = (action) => {
  return action.type.endsWith('/rejected');
};

const webhooksAdapter = createEntityAdapter({
  selectId: (item) => item.id,
});

const webhookSlice = createSlice({
  name: 'webhooks',
  initialState: {
    isFetching: false,
    metadata: {},
    entities: [],
    ids: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetAllWebhooks.fulfilled, (state, action) => {
      const { webhooks, meta } = action.payload;
      state.metadata = meta;
      webhooksAdapter.setAll(state, webhooks);
    });
    builder.addCase(doGetAllWebhooks.pending, (state) => {
      state.isFetching = true;
      state.metadata = {}; // Optionally reset the metadata
      webhooksAdapter.removeAll(state); // Clear the entities
    });
    builder.addCase(doCreateWebhook.fulfilled, (state, action) => {
      webhooksAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doUpdateWebhook.fulfilled, (state, action) => {
      webhooksAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doDeleteWebhook.fulfilled, (state, action) => {
      webhooksAdapter.removeOne(state, action.meta.arg);
    });
    builder.addMatcher(isActionWithPending, (state) => {
      state.isFetching = true;
    });
    builder.addMatcher(isActionWithFulfilled, (state) => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, (state) => {
      state.isFetching = false;
    });
  },
});

export const {
  selectAll: selectAllWebhooks,
  selectById: selectWebhookById,
  selectIds: selectWebhookIds,
} = webhooksAdapter.getSelectors((state) => state.webhooks);

const { reducer: webhookReducer } = webhookSlice;
export default webhookReducer;
